import { render, staticRenderFns } from "./FAQDetail.vue?vue&type=template&id=2e7bb3cf&scoped=true"
import script from "./FAQDetail.vue?vue&type=script&lang=js"
export * from "./FAQDetail.vue?vue&type=script&lang=js"
import style0 from "./FAQDetail.vue?vue&type=style&index=0&id=2e7bb3cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bb3cf",
  null
  
)

export default component.exports